import { http } from '@/http/axios.js'
// 分页列表
export function getListAPI(params) {
  return http({
    url: '/admin/storeGoodsModel/page',
    method: 'get',
    params
  })
}
// 型号下拉（供商品表单/列表按系列联动，params: { seriesId }）
export function getModelEnumListAPI(params) {
  return http({
    url: '/admin/storeGoodsModel/enumList',
    method: 'get',
    params
  })
}
// 系列下拉（门店商品系列 /list）
export function getSeriesListAPI(params) {
  return http({
    url: '/admin/storeGoodsSeries/enumList',
    method: 'get',
    params
  })
}
// detail
export function getDetailAPI(id) {
  return http({
    url: '/admin/storeGoodsModel/detail',
    method: 'get',
    params: { id }
  })
}
// add
export function addAPI(data) {
  return http({
    url: '/admin/storeGoodsModel/add',
    method: 'post',
    data
  })
}
// edit
export function editAPI(data) {
  return http({
    url: '/admin/storeGoodsModel/edit',
    method: 'post',
    data
  })
}
// delete
export function deleteAPI(id) {
  return http({
    url: '/admin/storeGoodsModel/delete',
    method: 'post',
    data: { id }
  })
}
